<div
  bsModal
  #reviewHistoryModal="bs-modal"
  [config]="{ show: false }"
  [rlTrapFocus]="{ setReturnFocus: '#edit-list-btn' }"
  (onHidden)="onHide()"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="review-history-modal-heading"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2
          class="modal-title"
          id="review-history-modal-heading"
          i18n="@@reviewHistoryModal-heading-reviewHistory"
        >
          Review history
        </h2>
      </div>

      <div class="modal-body u-overflow-x">
        <div
          *ngIf="state.modalControls.isLoading"
          class="text-center"
          role="status"
        >
          <i
            class="fal fa-spinner-third fa-5x fa-fw fa-spin"
            aria-hidden="true"
          ></i>
          <span class="sr-only" i18n="@@reviewHistoryModal-spinner-loading"
            >Loading...</span
          >
        </div>

        <div
          *ngIf="state.modalControls.loadingError ? true : false"
          class="alert alert-danger"
          role="alert"
        >
          <strong i18n="@@reviewHistoryModal-status-errorLoading"
            >Error!</strong
          >
          <ng-container
            i18n="@@reviewHistoryModal-status-errorLoadingPleaseRetry"
            >There was an error loading the review history for your list. Please
            try again.</ng-container
          >
        </div>

        <ng-container *ngIf="reviews ? true : false">
          <ng-container [ngSwitch]="reviews.length === 0">
            <div
              *ngSwitchCase="true"
              class="alert alert-info"
              i18n="@@reviewHistoryModal-status-neverBeenReviewed"
              role="status"
            >
              This list has never been reviewed
            </div>

            <table
              *ngSwitchDefault
              class="table c-reviews-history-modal__table"
            >
              <thead>
                <tr>
                  <th i18n="@@reviewHistoryModal-heading-requested">
                    Requested
                  </th>
                  <th i18n="@@reviewHistoryModal-heading-started">Started</th>
                  <th i18n="@@reviewHistoryModal-heading-completed">
                    Completed
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let review of reviews">
                  <td>
                    <time
                      *ngIf="review.requested_at"
                      [attr.datetime]="review.requested_at"
                    >
                      {{ review.requested_at | amLocale : locale | amTimeAgo }}
                    </time>
                    <ng-container
                      *ngIf="review.requested_by"
                      i18n="@@reviewHistoryModal-table-requestedBy"
                    >
                      by {{ review.requested_by.email }}
                    </ng-container>
                  </td>
                  <td>
                    <time
                      *ngIf="review.started_at"
                      [attr.datetime]="review.started_at"
                    >
                      {{ review.started_at | amLocale : locale | amTimeAgo }}
                    </time>
                    <ng-container
                      *ngIf="review.started_by"
                      i18n="@@reviewHistoryModal-table-startedBy"
                    >
                      by {{ review.started_by.email }}
                    </ng-container>
                  </td>
                  <td>
                    <time
                      *ngIf="review.completed_at"
                      [attr.datetime]="review.completed_at"
                    >
                      {{ review.completed_at | amLocale : locale | amTimeAgo }}
                    </time>
                    <ng-container
                      *ngIf="review.completed_by"
                      i18n="@@reviewHistoryModal-table-completedBy"
                    >
                      by {{ review.completed_by.email }}
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button
          (click)="onHide()"
          type="button"
          class="btn btn-default qa-btn-close"
          i18n="@@reviewHistoryModal-btn-close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
